import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetchCannedDashboard from 'hooks/useFetchCannedDashboard';
import useFetchCannedDashboardList from 'hooks/useFetchCannedDashboardList';

import Page from 'layout/Page';
import LayoutHandler from 'layout/dashboard-layouts/LayoutHandler';
import EmptyCannedDashboard from 'containers/EmptyCannedDashboard';
import Container from 'components/Container';
import useSaveRecentDashboard from 'hooks/useSaveRecentDashboard/useSaveRecentDashboard';
import DashboardDateButton from './DashboardDateButton';
import { Box, Typography } from '@material-ui/core';

const CannedDashboard = () => {
  const { masterObjectId, id } = useParams();
  const [state, dashboardsSet, dispatch] = useFetchCannedDashboardList(masterObjectId, id);
  const { isLoading } = state;
  const { dashboardsList, isDefaultTemplate, masterObjectName, isEmptyList } = dashboardsSet;


  // Splitting the responsibility for the masterObjectId list of canned dashboards and the set of widget for the current canned dashboard between two hooks to
  // decrease complexity and increase flexibility
  const [
    cannedDashboardApiState,
    cannedDashboardState,
    dispatchDashboardWidgets
  ] = useFetchCannedDashboard(masterObjectId, id);
  const { isLoading: isDashboardWidgetsLoading } = cannedDashboardApiState;
  const { widgets, dashboardData } = cannedDashboardState;
  useSaveRecentDashboard(dashboardData, masterObjectId, true);

  const [startDateState, setStartDateState] = useState(new Date("2000-01-01"));
  const [endDateState, setEndDateState] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [dateRangeTypeId, setDateRangeTypeId] = useState(1);
  const [dateMatchType, setDateMatchType] = useState(1);
  const [customDateMatchType, setCustomDateMatchType] = useState(3);

  const [dateState, setDateState] = useState({});

  if (isEmptyList) {
    return <EmptyCannedDashboard masterObjectName={masterObjectName} />;
  }

  return (
    <Page
      isCanned
      title={dashboardData && dashboardData.masterObjectName}
      tabs={dashboardsList}
      dashboardData={dashboardData}
      dashboardId={id}
      dispatchCannedDashboardList={dispatch}
      isDefaultTemplate={isDefaultTemplate}
      isLoading={isLoading}
    >
      <Container center maxWidth="xl">
        {widgets && widgets.length > 0 && (
          <>
          <Box display='flex' width='100%' justifyContent='flex-start' paddingBottom="10px" paddingTop='10px'>
            <Typography>Pick dates for the widgets</Typography>
            <DashboardDateButton
              startDate={startDateState}
              endDate={endDateState}
              dateRangeTypeId={dateRangeTypeId}
              dateMatchType={dateMatchType}
              customDateMatchType={customDateMatchType}
              updateStartDate={setStartDateState}
              updateEndDate={setEndDateState}
              updateDateRangeTypeId={setDateRangeTypeId}
              updateCustomDateMatchType={setCustomDateMatchType}
              updateDateMatchType={setDateMatchType}
              setDateState={setDateState}
            />
          </Box>
          <LayoutHandler
            layoutId={dashboardData.layout.id}
            widgets={widgets}
            updateWidget={dispatchDashboardWidgets}
            isDashboardLoading={isLoading || isDashboardWidgetsLoading}
            dashboardData={dashboardData}
            availableSlots={dashboardData.layout.slots}
            dispatchCannedDashboardList={dispatch}
            dateState={dateState}
          />
          </>
        )}
      </Container>
    </Page>
  );
};

export default CannedDashboard;
